export const ARTA_PROVENANCE_ANNOTATIONS = {
  enforced: 'arta.cubeangle.io/provenance-enforced',
  projectRef: 'arta.cubeangle.io/project-ref',
  entitlementId: 'arta.cubeangle.io/entitlement-id',
  capabilityPackId: 'arta.cubeangle.io/capability-pack-id',
  capabilityPackVersion: 'arta.cubeangle.io/capability-pack-version',
  templateRef: 'arta.cubeangle.io/template-ref',
  cloudTargets: 'arta.cubeangle.io/cloud-targets',
  signature: 'arta.cubeangle.io/provenance-signature',
  reservationId: 'arta.cubeangle.io/quota-reservation-id',
} as const;

export interface ArtaEntityProvenance {
  enforced: boolean;
  projectRef: string;
  entitlementId: string;
  capabilityPackId: string;
  capabilityPackVersion: string;
  templateRef: string;
  cloudTargets: string;
  reservationId?: string;
}

export function readArtaEntityProvenance(
  annotations: Record<string, string> | undefined,
): ArtaEntityProvenance | undefined {
  if (!annotations?.[ARTA_PROVENANCE_ANNOTATIONS.projectRef]) return undefined;
  return {
    enforced: annotations[ARTA_PROVENANCE_ANNOTATIONS.enforced] === 'true',
    projectRef: annotations[ARTA_PROVENANCE_ANNOTATIONS.projectRef],
    entitlementId: annotations[ARTA_PROVENANCE_ANNOTATIONS.entitlementId] ?? '',
    capabilityPackId:
      annotations[ARTA_PROVENANCE_ANNOTATIONS.capabilityPackId] ?? '',
    capabilityPackVersion:
      annotations[ARTA_PROVENANCE_ANNOTATIONS.capabilityPackVersion] ?? '',
    templateRef: annotations[ARTA_PROVENANCE_ANNOTATIONS.templateRef] ?? '',
    cloudTargets: annotations[ARTA_PROVENANCE_ANNOTATIONS.cloudTargets] ?? '[]',
    reservationId:
      annotations[ARTA_PROVENANCE_ANNOTATIONS.reservationId] || undefined,
  };
}
